// ─────────────────────────────────────────────────────────
// supabase.ts — Single Supabase client initialisation
//
// Phase 5: credentials sourced from env.ts (single source
// of truth). Placeholder values kept so the client always
// initialises — the app runs offline when USE_SUPABASE_DB
// is false, even without real credentials.
//
// Phase 6 hardening:
//   + storageKey scoped to app — avoids session bleed
//   + flowType 'pkce' — more secure than implicit for SPAs
//   + debug enabled only in DEV
// ─────────────────────────────────────────────────────────
import { createClient } from '@supabase/supabase-js'
import { ENV } from '@/lib/env'

const supabaseUrl = ENV.SUPABASE_URL  || 'https://placeholder.supabase.co'
const supabaseKey = ENV.SUPABASE_ANON_KEY || 'placeholder-anon-key'

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession:     true,
    autoRefreshToken:   true,
    detectSessionInUrl: true,
    flowType:           'pkce',
    storageKey:         'cbd_auth',    // scoped — won't clash with other Supabase apps
    debug:              false,   // GoTrueClient debug floods console — keep off even in DEV
  },
  global: {
    headers: {
      'x-app-name': 'CivilBillDesk',
    },
  },
})

export default supabase
